<ng-template #loaderTemplate>
  <ui-progress-bar [isIndeterminate]="true" class="pos-absolute"></ui-progress-bar>
</ng-template>

<ng-template #errorTemplate>
  <span class="flex result-text">{{ 'errorContent' | translate }}</span>
  <ol>
    <li class="flex layout-fill">{{ 'errorCause0' | translate }}</li>
    <li class="flex layout-fill">{{ 'errorCause1' | translate }}</li>
    <li class="flex layout-fill">{{ 'errorCause2' | translate }}</li>
  </ol>
</ng-template>

<div class="flex layout layout-fill p-20">
  <div *ngIf="!this.isLoading; else loaderTemplate" class="flex layout-fill">
    <h1>{{ 'header' | translate }}</h1>
    <div *ngIf="this.isSuccessful; else errorTemplate" class="layout-fill">
      <p class="layout-fill layout-row">
        <span class="flex result-text">{{ 'success' | translate }}</span>
      </p>
    </div>
  </div>
</div>
